import Container from "../Container";
import Title from "../Title";
import { Children, Context, Description, TextCenter } from "./style";

type SectionProps = {
  title?: string;
  description?: string;
  secondarySection?: boolean;
  children: React.ReactNode;
  referance?: React.MutableRefObject<any>;
};

export default function Section({
  title,
  description,
  secondarySection = false,
  children,
  referance,
}: SectionProps) {
  return (
    <Context backgroundColor={secondarySection} ref={referance}>
      <Container>
        <TextCenter>
          {title && <Title name={title} secondarySection={secondarySection} />}
          {description && <Description>{description}</Description>}
        </TextCenter>
        <Children haveTitle={!!title}>{children}</Children>
      </Container>
    </Context>
  );
}
